let dev = false;

let HOST = "",
  SOCKJS_URL = "",
  BROKER_URL = "";

if (dev) {
  HOST = "http://localhost:9090";
  SOCKJS_URL = "http://localhost:9090/websocket";
  BROKER_URL = "ws://localhost:9090/websocket";
} else {
  HOST = "/";
  SOCKJS_URL = "https://zalo.salework.net/websocket";
  BROKER_URL = "wss://zalo.salework.net/websocket";
}
export default {
  DEV: dev,
  HOST: HOST,
  SOCKJS_URL,
  BROKER_URL
};

